export const translations = {
    en: {
        "sEmptyTable": "No data available in table",
        "sInfo": "_START_ - _END_ of _TOTAL_",
        "sInfoEmpty": "Showing 0 to 0 of 0 entries",
        "sInfoFiltered": "",
        "sInfoPostFix": "",
        "sInfoThousands": ",",
        "sLengthMenu": "_MENU_",
        "sLoadingRecords": "Loading...",
        "sProcessing": "Processing...",
        "sSearch": "Search:",
        "sZeroRecords": "No matching records found",
        "oPaginate": {
            "sFirst": "First",
            "sLast": "Last",
            "sNext": "<i class=\"fa fa-chevron-right\"></i>",
            "sPrevious": "<i class=\"fa fa-chevron-left\"></i>"
        },
        "oAria": {
            "sSortAscending": ": activate to sort column ascending",
            "sSortDescending": ": activate to sort column descending"
        }
    },
    pl: {
        "processing": "Przetwarzanie ...",
        "search": "Szukaj:",
        "lengthMenu": "_MENU_",
        "info": "_START_-_END_ z _TOTAL_",
        "infoEmpty": "0 z 0",
        "infoFiltered": "",
        "infoPostFix": "",
        "loadingRecords": "Wczytywanie ...",
        "zeroRecords": "Nie znaleziono pasujących pozycji",
        "emptyTable": "Brak danych",
        "paginate": {
            "first": "Pierwsza",
            "previous": '<i class="fa fa-chevron-left"></i>',
            "next": '<i class="fa fa-chevron-right"></i>',
            "last": "Ostatnia"
        },
        "aria": {
            "sortAscending": ": aktywuj, by posortować kolumnę rosnąco",
            "sortDescending": ": aktywuj, by posortować kolumnę malejąco"
        },
        "buttons": {
            "colvis": "dostosuj kolumny"
        }
    }
};
